var React = require('react');

function IcnCheck (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#29DDCC","key":0}),React.createElement("path",{"d":"M22.6668 10.6667L14.3891 21.3333L9.3335 16.1641","stroke":"#0C0D0F","strokeWidth":"2.5","strokeLinecap":"round","key":1})]);
}

IcnCheck.defaultProps = {"aria-label":"startpage does this","width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = IcnCheck;

IcnCheck.default = IcnCheck;
